import React from 'react';
import { GenericAlign } from '../../../../../packages/constants/generic';
import { INormalizedTeam } from '../../../../../packages/types';
import { SMPContainer, SMPFlex, SMPLinkWrapper, SMPSportEntity, SMPText } from '@velinsi/smp-widgets-ui';
import { setNationalParticipantBorder } from '@sportal365/smp-widget-utils';
import { NATIONAL } from '../../../../../packages/constants/sportRegions';

interface ILineupsProfileHeadProps {
  team: INormalizedTeam;
  align?: GenericAlign;
  primaryLink?: {
    url: string;
    urlTarget: string;
    callback?: () => void;
  };
  isMainImageRound?: boolean;
}

export const LineupsProfileHead: React.FC<ILineupsProfileHeadProps> = ({
  team,
  align = GenericAlign.LEFT,
  primaryLink,
  isMainImageRound = true,
}) => {
  const onClick = () => {
    if (primaryLink?.callback) {
      primaryLink.callback();
    }
  };

  const isTeamNational = team.type === NATIONAL;
  const profileHeadStyles = setNationalParticipantBorder(isTeamNational);

  return (
    <SMPLinkWrapper href={primaryLink?.url} target={primaryLink?.urlTarget}>
      <SMPContainer
        onClick={onClick}
        css={{
          display: 'flex',
          py: '$2',
          ai: 'center',
          fd: align === GenericAlign.LEFT ? 'row' : 'row-reverse',
          width: '100%',
          padding: '0',
        }}
      >
        <SMPSportEntity
          className='profile-link'
          css={{
            flex: 'unset',
            justifyContent: align === GenericAlign.LEFT ? 'start' : 'end',
            borderRadius: isMainImageRound ? '$round' : 'unset',
            [align === GenericAlign.LEFT ? 'marginRight' : 'marginLeft']: '$2',
            size: '$6_5',
            backgroundImage: `url("${team.logo}")`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            ...profileHeadStyles,
          }}
        />
        <SMPFlex>
          <SMPText
            variant='contrast'
            weight='700'
            css={{
              ta: align === GenericAlign.LEFT ? 'start' : 'end',
              fontSize: '$4',
              lh: '24px',
            }}
          >
            {team.name}
          </SMPText>
        </SMPFlex>
      </SMPContainer>
    </SMPLinkWrapper>
  );
};
